import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=4dd31f29&scoped=true&"
import script from "./PollList.vue?vue&type=script&lang=ts&"
export * from "./PollList.vue?vue&type=script&lang=ts&"
import style0 from "./PollList.vue?vue&type=style&index=0&id=4dd31f29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd31f29",
  null
  
)

export default component.exports